import { ColumnType } from 'antd/es/table';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation } from "react-router";
import { phaseApis } from "../../api/Phase";

const PettyCashReport = () => {
    const [paidToFilterData, setPaidToFilterData] = useState([]);
    const dispatch = useDispatch();
    const location = useLocation();
    const { id: projectId} = location.state || {};


    const columns: ColumnType<any>[] = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Transaction Type",
            dataIndex: "transactionType",
            key: "transactionType",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Balance",
            dataIndex: "balance",
            key: "balance",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Paid To",
            dataIndex: "paidTo",
            key: "paidTo",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
    ]


    const fetchStatusDropdown = async () => {
        try {
            const response = await phaseApis.getOwnersFilterData(
                projectId?.toString()
            );
            const { data, status } = response || {};
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item.userName,
                        value: item.userId,
                    };

                });
                setPaidToFilterData(options);}
        } catch (error) {
            console.error("eroor")
        }
    }

    useEffect(() => {
        fetchStatusDropdown();
        dispatch(
            updateMenuData([
                {
                    text: "Petty Cash Inflow/Outflow Report",
                    link: "/pms/petty-cash-inflow-outflow-report",
                },
            ])
        );
    }, []);
    return (
        <>
            <Template1
                moduleKey={window.location.pathname}
                columns={columns}
                pageTitle='Petty Cash Report'
                pageDescription=''
                previousPath={{
                    link: "/pms/project/reports",
                    state: location.state,
                }}
                filters={{
                    defaultFilters: {
                        dateRange: {
                            title: "Custom Date Range",
                        },
                    },
                    customFilters: [
                        {
                            type: "multiple_selection",
                            name: "paidTo",
                            label: "paidTo",
                            options: paidToFilterData,
                        },

                    ]
                }}
            />
        </>
    )
};

export default PettyCashReport;
